import React, { useState, useEffect, useMemo } from "react";
import { baseUrl } from "../../../../../../../../../../network/constants/constants";
import { getConfig } from "../../../../../../../../../../network/auth";
import axios from "../../../../../../../../../../network/api";
import ServiceManTable from "./serviceManTable/serviceManTable";
import ServiceManForm from "./serviceManForm/serviceManForm";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import { Spinner } from "react-bootstrap";
import "./serviceMan.css";
import ServiceManLocation from "./serviceManLocation/serviceManLocation";
import RealTimeServiceManDataGrid from "./serviceManTable/RealTimeServiceManDataGrid";
import AppConstants from "../../../../../../../../../AppConstants"; 

// --- CONFIGURATION ---
const JWT_TOKEN_KEY = AppConstants.JWT; 
const WS_BASE_URL_WORKER = "wss://main.hifiservices.in/ws/dashboard/worker-availability/"; 
// ---------------------

const ServiceManscreen = ({ franchiseId }) => {
  const [loading, setLoading] = useState(false);
  const [serviceManList, setServiceManList] = useState([]); // Full list from API (for the bottom table)
  const [serviceList, setServiceList] = useState([]);
  const [open, setOpen] = useState(false);
  const [openLocation, setOpenLocation] = useState(false);
  const [selectedServiceMan, setSelectedServiceMan] = useState(null);
  const [showSuspendPopup, setShowSuspendPopup] = useState(false);
  const [serviceManToSuspend, setServiceManToSuspend] = useState(null);
  const [serviceManId, setServiceManId] = useState(null);
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  
  // New States for Real-Time Component
  const [realTimeWorkersCount, setRealTimeWorkersCount] = useState(0); 
  const [isTokenAvailable, setIsTokenAvailable] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleAddForm = () => {
    setSelectedServiceMan();
    setOpen(true);
  };

  const handleEditForm = (serviceMan = null) => {
    setSelectedServiceMan(serviceMan);
    setOpen(true);
  };
  const handleCloseForm = () => {
    setSelectedServiceMan(null);
    setOpen(false);
  };
  const handleSuspendClose = () => {
    setShowSuspendPopup(false);
  };

  const handleLocation = (id) => {
    const serviceManId = id.id;
    setOpenLocation(true);
    fetchServiceManDetail(serviceManId);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar({ ...snackbar, open: false });
  };

  const fetchServiceManDetail = (serviceManId) => {
    setLoading(true);
    axios
      .get(baseUrl + `businessadmin/worker/${serviceManId}/`, config)
      .then((response) => {
        setLoading(false);
        setLatitude(response.data.latitude);
        setLongitude(response.data.longitude);
      })
      .catch((error) => {
        console.error("Serviceman Error:", error);
        setLoading(false);
      });
  };

  const handleCloseLocation = () => {
    setOpenLocation(false);
  };

  const handleSelectServiceManId = (id) => {
    setServiceManId(id);
  };

  const config = useMemo(() => {
    return getConfig();
  }, []);

  const fetchServiceMan = () => {
    setLoading(true);
    axios
      .get(baseUrl + `superadmin/workers-by-business/${franchiseId}`, config)
      .then((response) => {
        setServiceManList(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("ServiceMan Error:", error);
        setLoading(false);
      });
  };

  const fetchService = () => {
    setLoading(true);
    axios
      .get(baseUrl + `app/services-list-by-business/${franchiseId}/`, config)
      .then((response) => {
        setLoading(false);
        setServiceList(response.data);
      })
      .catch((error) => {
        console.error("Service Error:", error);
        setLoading(false);
      });
  };

  const handleSuspendClick = (serviceMan) => {
    setServiceManToSuspend(serviceMan.user);
    setShowSuspendPopup(true);
  };

  const confirmSuspend = () => {
    if (serviceManToSuspend) {
      suspendServiceMan(serviceManToSuspend);
    }
    setShowSuspendPopup(false);
    setServiceManToSuspend(null);
  };

  const suspendServiceMan = (servicemanId) => {
    setLoading(true);

    const serviceMan = serviceManList.find((man) => man.user === servicemanId);
    const isSuspended = serviceMan?.is_suspended ? "False" : "True";

    axios
      .post(
        `${baseUrl}auth/suspend-user/${servicemanId}/`,
        { is_suspended: isSuspended },
        {
          headers: {
            ...config.headers,
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((response) => {
        fetchServiceMan();
        setLoading(false);
        setSnackbar({
          open: true,
          message: serviceMan?.is_suspended
            ? "Serviceman activated successfully"
            : "Serviceman suspended successfully",
          severity: "success",
        });
      })
      .catch((error) => {
        console.error("Error deleting category:", error);
        setLoading(false);
        setSnackbar({
          open: true,
          message: "Something went wrong. Please try again",
          severity: "error",
        });
      });
  };

  const handleRefresh = () => {
    fetchServiceMan();
  };
  
  // Logic to check token availability
  useEffect(() => {
    const token = localStorage.getItem(JWT_TOKEN_KEY);
    if (token) {
      setIsTokenAvailable(true);
    } else {
      setIsTokenAvailable(false);
    }
    fetchServiceMan();
    fetchService();
  }, []);

  const handleFormSubmit = (formData) => {
    const url = selectedServiceMan
      ? `${baseUrl}superadmin/service-man-edit/${selectedServiceMan.id}/`
      : `${baseUrl}superadmin/service-man-create/`;

    const method = selectedServiceMan ? "put" : "post";

    const form = new FormData();
    if (formData.profilePic) {
      form.append("worker_image", formData.profilePic);
    }
    form.append("worker_name", formData.serviceManName);
    form.append("service", JSON.stringify(formData.service));
    form.append("mobile_number", formData.phone);
    form.append("experience", formData.experience);
    form.append("address", formData.address);
    form.append("location", formData.location);
    form.append("district", formData.district);
    form.append("email", formData.email);
    form.append("postal_name", formData.postalName);
    form.append("zipnumber", formData.zipNumber);
    form.append("business", franchiseId);

    axios({
      method,
      url,
      data: form,
      headers: {
        Authorization: config.headers.Authorization,
      },
    })
      .then((response) => {
        setSnackbar({
          open: true,
          message: response.data.message,
          severity: "success",
        });
        fetchServiceMan();
        setOpen(false);
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message ||
          "An error occurred. Please try again.";
        setSnackbar({
          open: true,
          message: errorMessage,
          severity: "error",
        });
      });
  };

  return (
    <div className="mt-4 service-man-container">
      
      {/* 1. CSS STYLES ADDED INTERNALLY (For the Red Buttons) */}
      <style>{`
        /* Container for absolute positioning context */
        .service-man-container {
            position: relative;
        }

        /* Common Button Styles */
        .btn-add-service-man, .btn-refresh-service-man {
            border: none;
            padding: 10px 20px; 
            font-size: 18px;
            border-radius: 5px;
            cursor: pointer;
            background: #ff4d4d !important; /* RED background for both buttons */
            color: white; /* WHITE text color for both buttons */
            position: absolute;
            top: -50px; 
            z-index: 999;
            font-weight: 500;
        }
        
        /* Specific Positions */
        .btn-add-service-man {
            right: 25px;
        }
        .btn-refresh-service-man {
            right: 325px; 
        }

        /* Hover Effect (Maintain contrast for usability) */
        .btn-add-service-man:hover, .btn-refresh-service-man:hover {
            background: #e64040 !important; /* Slightly darker red on hover */
        }
        
        /* Search Field Styles (if serviceMan.css is missing) */
        .search-container {
            width: 250px;
            margin: 10px 0; 
        }
        .search-field {
            background: #fafafa;
            border: none;
            outline: none;
            box-shadow: 0 0px 3px rgba(0, 0, 0, 0.25);
        }
      `}</style>
      {/* END CSS STYLES */}

      {/* 2. Real-Time Technician Status Table (New) */}
      {isTokenAvailable && !loading ? ( 
        <RealTimeServiceManDataGrid 
          franchiseId={franchiseId} 
          websocketUrl={WS_BASE_URL_WORKER} 
          setRealTimeWorkersCount={setRealTimeWorkersCount}
          tokenKey={JWT_TOKEN_KEY} 
          // REMOVED initialWorkers prop to make the table start empty, 
          // showing only WebSocket-updated technicians.
        />
      ) : (
        <div style={{
          textAlign: 'center', 
          color: '#d32f2f', 
          padding: '20px', 
          fontWeight: 'bold',
          backgroundColor: '#fff3e0',
          borderRadius: '8px',
          margin: '10px 0',
          border: '1px solid #ff4d4d'
        }}>
          {loading ? "Loading technician list..." : "⚠️ Authentication token not found. Real-time status feed disabled."}
        </div>
      )}

      {/* 3. Action Buttons (Using absolute positioning classes) */}
      
        <button className="btn-refresh-service-man" onClick={handleRefresh}>
        ⟳ Refresh 
        </button>
        <button className="btn-add-service-man" onClick={handleAddForm}>
          + Add Technician Details
        </button>
      
      
      {/* Original Content / Table */}
      {loading ? (
        <div className="loader-container">
          <Spinner className="spinner-loader" />
        </div>
      ) : (
        <ServiceManTable
          serviceManList={serviceManList}
          onEdit={handleEditForm}
          onSuspend={handleSuspendClick}
          onLocation={handleLocation}
          onSelectServiceManId={handleSelectServiceManId}
        />
      )}

      <ServiceManForm
        open={open}
        onClose={handleCloseForm}
        serviceList={serviceList}
        serviceMan={selectedServiceMan}
        onSubmit={handleFormSubmit}
      />

      <Dialog
        open={showSuspendPopup}
        onClose={() => setShowSuspendPopup(false)}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>Are you sure?</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {serviceManList.find((man) => man.user === serviceManToSuspend)
              ?.is_suspended
              ? "Do you want to activate this service man?"
              : "Do you want to suspend this service man?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            size="small"
            color={
              serviceManList.find((man) => man.user === serviceManToSuspend)
                ?.is_suspended
                ? "primary"
                : "error"
            }
            style={{ textTransform: "none" }}
            onClick={confirmSuspend}
          >
            {serviceManList.find((man) => man.user === serviceManToSuspend)
              ?.is_suspended
              ? "Activate"
              : "Suspend"}
          </Button>
          <Button
            size="small"
            style={{
              textTransform: "none",
              color: "grey",
              outline: "1px solid grey",
            }}
            onClick={handleSuspendClose}
          >
            cancel
          </Button>
        </DialogActions>
      </Dialog>
      <ServiceManLocation
        open={openLocation}
        onClose={handleCloseLocation}
        serviceManId={serviceManId}
        latitude={latitude}
        longitude={longitude}
      />
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default ServiceManscreen;